import { Box } from '@chakra-ui/layout';
import { ReactNode } from 'react';

const CardMy = ({ children, transparent }: { children: ReactNode; transparent?: boolean }) => (
    <Box
        className="CardMy"
        bg={transparent ? 'transparent' : 'white'}
        borderRadius="16px"
        boxShadow={!transparent && '0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)'}
        padding="24px"
        minHeight="200px" // TODO remove this
        borderWidth={transparent && '1px'}
        borderColor={transparent && 'gray.300'}
    >
        {children}
    </Box>
);

export default CardMy;
